<template>
  <div class="app_contain_w site_min_w">
    <MyTop />

    <MyHeader />

    <MyNav />
    <TipsBar/>
    <MyMain v-if="$route.path === '/'" />
    <router-view />

    <MyFooter />
    <!-- 固定导航栏 -->
    <!-- <SiteFixedNav /> -->
  </div>
</template>

<script>

import MyHeader from '@/views/public_0983cc/MyHeader.vue'
import MyFooter from '@/views/public_0983cc/MyFooter.vue'
import MyTop from '@/views/public_0983cc/MyTop.vue'
import MyNav from '@/views/public_0983cc/MyNav.vue'
import TipsBar from '@/components/public/TipsBar.vue'
import SiteFixedNav from '@/components/base/SiteFixedNav.vue'
import MyMain from './home/index.vue'
import SelectLoc from './home/SelectLoc.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Async',
  components: {
    MyHeader,
    MyFooter,
    MyTop,
    MyNav,
    TipsBar,
    SiteFixedNav,
    MyMain,
    SelectLoc,
  },
  metaInfo() {
    return {
      title: this.siteInfo?.name
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['siteInfo'])
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }

}
</script>

<style lang="scss" scoped>
.app_contain_w {
  background: #fafafa;
}

::v-deep .location_w {
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // right: 43%;
  position: relative;
  height: 34px;
  line-height: 34px;
  border-radius: 17px;
  margin: 0 10px;
  padding: 0 15px;
  .name {
    margin-left: 5px;
  }
  .select_loc_w{
    position: absolute;
    top:0;
    left: 0;
  }
}
</style>
